import * as yup from 'yup';

export const newTransferenciaSchema = yup.object({
  bodega_origen: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  bodega_destino: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  ubicacion_origen: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido')
    .nullable(),
  ubicacion_destino: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido')
    .nullable(),
  solicitado_por: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  //motivo: yup.string().required('Campo Requerido'),
});


export const newTrasladoInventarioSchema = yup.object({
  bodega_origen: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  bodega_destino: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  ubicacion_origen: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido')
    .nullable(),
  ubicacion_destino: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido')
    .nullable(),
  solicitado_por: yup
    .string()
    .required('Campo Requerido')
    .typeError('Campo Requerido'),
  motivo: yup.string().required('Campo Requerido'),
  unidad_transporte: yup.string().required('Campo Requerido'),
});
